import { autoWebViewJs } from "../../AutoWebViewJs";


function read<T>(key:string, defaultValue?:T):T{
    let script = `var v = com.fanfanlo.lib.store.SharedPrefs.read("${key}");\n v;`
    // console.log('autojs store utils read script=', script)
    let {javaResultString:v, error} = autoWebViewJs.callScript<string>(script)
    // console.log('read_fn key=', key, 'java result string', v,)
    if(v){

        try{
            let x = JSON.parse(decodeURIComponent(v));
            // console.log('readdddddddddd', 'x=', x, 'script=', script)
            return x as T;
        }catch(e){
            console.log("storage get item err", e);
        }
    }
    // console.log('return default', `key=${key}`, defaultValue)
    return defaultValue || (v as T);
}

function write<T>(key:string ,v:T){
    // console.log('autojs store utils write', 'key=', key)
    const s = encodeURIComponent(JSON.stringify(v));
    // console.log('autojs store utils write', 's=', s)
    let script = `var v = com.fanfanlo.lib.store.SharedPrefs.write("${key}", "${s}");`;
    // console.log('auto js store utils write', 'script=', script)
    autoWebViewJs.callScript(script);
    // console.log('sssssssssssssssave', 'key=', key, 's=', s, 'script=', script)
}

export const autoJsStoreUtils = {
    write,
    read,
}